import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUser1Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 14C18.6887 14 20.8818 16.1223 20.9954 18.7831L21 19V21C21 21.5523 20.5523 22 20 22C19.4872 22 19.0645 21.614 19.0067 21.1166L19 21V19C19 17.4023 17.7511 16.0963 16.1763 16.0051L16 16H8C6.40232 16 5.09634 17.2489 5.00509 18.8237L5 19V21C5 21.5523 4.55228 22 4 22C3.48717 22 3.06449 21.614 3.00673 21.1166L3 21V19C3 16.3113 5.12231 14.1182 7.78311 14.0046L8 14H16ZM12 2C14.7614 2 17 4.23858 17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7C7 4.23858 9.23858 2 12 2ZM12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4Z",
		fill: "currentColor"
	})
});
export default SvgUser1Line;
